import React from 'react';
import { GetServerSideProps } from 'next';
import getConfig from 'next/config';
import { NextSeo, SiteLinksSearchBoxJsonLd } from 'next-seo';
import BasicLayout from 'layout/Basic';
import { convertProps } from 'lib/parseAPIResponse';
import EventList from 'containers/Events/List';
import createFromObject from 'lib/queryString';

type Props = {
    ads: PageAds;
    events: {
        items: Occurrence[];
        results: number;
        currentPage: number;
        numberOfPages: number;
        next: boolean;
        prev: boolean;
        paginate: boolean;
    };
    branch: Branch;
};

export const EventsPage = (props: Props): React.JSX.Element => {
    const { url, name } = getConfig().publicRuntimeConfig;
    return (
        <BasicLayout ads={props.ads}>
            <NextSeo title={`Wydarzenia | ${name}`} />
            <SiteLinksSearchBoxJsonLd
                url={url}
                potentialActions={[
                    {
                        target: `${url}/wydarzenia?name`,
                        queryInput: 'name'
                    }
                ]}
            />
            <EventList {...props} $sectionTitle="LISTA WYDARZEŃ RYNKU MOTORYZACYJNEGO" />
        </BasicLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
    const { apiUrl } = getConfig().publicRuntimeConfig;

    return Promise.all([
        fetch(
            `${apiUrl}/public/api/events${createFromObject(
                query as Record<string, string | number>
            )}`
        ),
        fetch(`${apiUrl}/public/api/naszadsik?path=wydarzenia`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
};

export default EventsPage;
